import { Col, Flex, message, Row } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ExternalWebhook } from "@rumble-it/common-lib/types/models/ExternalWebhook.interface";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchExternalWebhookById,
  updateExternalWebhookById,
} from "@/lib/api/resources/externalWebhooks";
import { ExternalWebhookFormCard } from "./components/ExternalWebhookForm";

export const ExternalWebhookEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const externalWebhookQuery = useQuery({
    queryKey: ["ExternalWebhook", id],
    queryFn: () => fetchExternalWebhookById(id),
  });

  const updateExternalWebhookMutation = useMutation({
    mutationFn: (data: ExternalWebhook) => updateExternalWebhookById(id, data),
    onSuccess: () => {
      navigate(`/external-webhooks/${id}`);
      message.success("Externe webhook succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de externe webhook",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ExternalWebhookFormCard
              loading={externalWebhookQuery.isLoading}
              initialValues={externalWebhookQuery.data}
              mutation={updateExternalWebhookMutation}
              title="Externe webhook bijwerken"
              buttonText="Bijwerken"
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
